import apiClient from "utility/apiClient";

// filtro i nuovi permessi e controllo che siano diversi da quelli esistenti
// ottenendo un array con solo i permessi che sono effettivamente cambiati
function filterPermissions(permissions, newPermissions) {
  if (!newPermissions) return permissions;
  return newPermissions.filter(newPermission => {
    const changedPermission = permissions.find(p => p.id === newPermission.id);

    return (
      changedPermission &&
      changedPermission.permission !== newPermission.permission
    );
  });
}

const api = {
  setPermessi: function setPermessi({
    id,
    itemType,
    permissions,
    applyToChildren,
  }) {
    const permessi = Array.isArray(permissions)
      ? permissions
          .map(permission => `${permission.id}:${permission.permission}`)
          .join(",")
      : permissions;

    if (!permessi) return;

    return apiClient()({
      action: "set_permessi_oggetto",
      data: {
        id_oggetto: id,
        tipo_oggetto: itemType,
        permessi,
        cascata: applyToChildren,
      },
    });
  },
  deleteItem: function deleteItem({ id, itemType }) {
    return apiClient()({
      action: "remove_item",
      data: {
        id,
        itemType,
      },
    });
  },
};

export const deleteItem = ({ id, itemType }) => async (dispatch, getState) => {
  try {
    await api.deleteItem({ id, itemType });
  } catch (err) {
    console.log(err);
  }
};

export const setPermissions = ({
  id,
  itemType,
  permissions,
  newPermissions,
  applyToChildren,
}) => async dispatch => {
  const filteredPermissions = filterPermissions(permissions, newPermissions);

  try {
    await api.setPermessi({
      id,
      itemType,
      permissions: filteredPermissions,
      applyToChildren,
    });
  } catch (err) {
    console.log(err);
    throw err;
  }
};
